var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"app-main"},[_c('div',{staticClass:"content-wrap"},[_c('section',{staticClass:"content-section"},[_c('header',{staticClass:"section-header"},[_c('h2',{staticClass:"section-title"},[_vm._v("404")])])])])])
}]

export { render, staticRenderFns }